module.exports = __webpack_public_path__ + "static/30-d6fb1378f7b82050745023e0dd0b82db.gif";